import React from "react";
import cx from "classnames";
//
import Icon from "./Icon";
import Bubble from "./Bubble";

export default function Tabs({ items, selected, onChange, className }) {
  return (
    <ol className={cx("tabs", "o-list-inline", className)}>
      {items.map((item) => (
        <li
          key={item.value}
          className={cx("tabs__item", {
            active: item.value === selected,
            "tabs__item--icon": item.icon !== undefined,
          })}
          onClick={(ev) => onChange(item.value)}
        >
          {item.value === "videos" && <Bubble title="new" />}
          {item.name} {item.icon && <Icon name={item.icon} />}
        </li>
      ))}
    </ol>
  );
}
